import { render, staticRenderFns } from "./ChangeOfRepresentativesForeign.vue?vue&type=template&id=6e7838f3&scoped=true&"
import script from "./ChangeOfRepresentativesForeign.vue?vue&type=script&lang=js&"
export * from "./ChangeOfRepresentativesForeign.vue?vue&type=script&lang=js&"
import style0 from "./ChangeOfRepresentativesForeign.vue?vue&type=style&index=0&id=6e7838f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7838f3",
  null
  
)

export default component.exports